<div class="container-fluid p-0 h-100">
    <agm-map
        class="h-100 rounded map"
        [disableDoubleClickZoom]="true"
        [disableDefaultUI]="true"
        [zoomControl]="true"
        [latitude]="avgLat"
        [longitude]="avgLong"
        [zoom]="zoom"
        [mapTypeId]="'hybrid'"
        (mapReady)="initDrawManager($event)"
        [styles]="mapStyle"
    >
        <agm-info-window [latitude]="infoWindowLat" [longitude]="infoWindowLng" #infoWindow>
            <div>
                {{ polyInfo }}
            </div>
        </agm-info-window>
    </agm-map>
    <div id="map-actions-section" class="d-flex map-actions-overlay position-absolute p-3">
        <div class="pr-3">
            <div class="d-flex back-overlay px-3 py-2">
                <button
                    class="btn btn-backoffice btn-yellow mr-3"
                    [disabled]="this.isDrawing || this.isShowingLinks || this.isAddingPath || this.isDeletingSphere"
                    (click)="onShortcuts()"
                >
                    <img class="btn-backoffice-img pb-2" src="assets/img/ic_star.svg" />
                    <div class="btn-backoffice-span">
                        <span>{{ "NURSERY_MAP_BUTTON_SHORTCUTS" | translate }}</span>
                    </div>
                </button>

                <button
                    class="btn btn-backoffice btn-blue mr-3"
                    [disabled]="this.isShowingShortcuts || this.isShowingLinks || this.isAddingPath || this.isDeletingSphere"
                    (click)="onEditPolygons()"
                >
                    <img class="btn-backoffice-img pb-2" src="assets/img/ic_fence.png" />
                    <div class="btn-backoffice-span">
                        <span>{{ "NURSERY_MAP_BUTTON_FENCES" | translate }}</span>
                    </div>
                </button>

                <button
                    class="btn btn-backoffice btn-red mr-3"
                    [disabled]="this.isDrawing || this.isShowingShortcuts || this.isShowingLinks || this.isAddingPath"
                    (click)="toggleRemoveSphere()"
                >
                    <img class="btn-backoffice-img pb-2" src="assets/img/clear-24px.svg" />
                    <div class="btn-backoffice-span">
                        <span>{{ "NURSERY_MAP_BUTTON_REMOVE_SPHERE" | translate }}</span>
                    </div>
                </button>

                <button
                    class="btn btn-backoffice btn-turquoise"
                    [disabled]="this.isDrawing || this.isShowingShortcuts || this.isAddingPath || this.isDeletingSphere"
                    (click)="togglePolylines()"
                >
                    <img class="btn-backoffice-img pb-2" src="assets/img/segments.png" />
                    <div class="btn-backoffice-span">
                        <span>{{ "NURSERY_MAP_BUTTON_PATHS" | translate }}</span>
                    </div>
                </button>
            </div>
        </div>
        <div *ngIf="this.isShowingLinks" class="pr-3">
            <div class="d-flex back-overlay px-3 py-2">
                <button
                    class="btn btn-backoffice btn-green"
                    [ngClass]="{ 'mr-3': this.selectedPolyline }"
                    (click)="toggleAddPath()"
                >
                    <img class="btn-backoffice-img pb-2" src="assets/img/ic_add.svg" />
                    <div class="btn-backoffice-span">
                        <span>{{ "NURSERY_MAP_BUTTON_ADD_PATH" | translate }}</span>
                    </div>
                </button>
                <button
                    *ngIf="this.selectedPolyline && !this.isAddingPath"
                    class="btn btn-backoffice btn-red"
                    (click)="removePath()"
                >
                    <img class="btn-backoffice-img pb-2" src="assets/img/clear-24px.svg" />
                    <div class="btn-backoffice-span">
                        <span>{{ "NURSERY_MAP_BUTTON_REMOVE_PATH" | translate }}</span>
                    </div>
                </button>
            </div>
        </div>
        <div *ngIf="this.isDrawing && !this.polygonEditorVisible" class="d-flex align-items-start map-actions-modes">
            <button (click)="onDrawingEdit()" class="btn p-1 btn-backoffice-mode">
                <img class="btn-backoffice-mode-img" src="assets/img/edit-24px.svg" />
            </button>
            <button (click)="onDrawingNew()" class="btn p-1 btn-backoffice-mode btn-backoffice-mode-btm">
                <img class="btn-backoffice-mode-img" src="assets/img/ic_add.svg" />
            </button>
        </div>
    </div>

    <polygon-editor
        *ngIf="this.polygonEditorVisible"
        [products]="this.products"
        [selectedProduct]="this.currentPolygonProduct"
        [selectedProductInfo]="this.currentPolygonProductMeasure"
        (save)="onPolygonSave($event)"
        (delete)="onPolygonDelete()"
        id="polygon-edit-overlay"
        class="position-absolute justify-content-center"
    >
    </polygon-editor>

    <shortcut-list
        *ngIf="this.isShowingShortcuts"
        [nurseryUUID]="this.nurseryUUID"
        [editEnabled]="false"
        (sphereChosen)="onSphereChosen($event)"
        id="shortcut-list"
        class="position-absolute justify-content-center"
    >
    </shortcut-list>
</div>
